// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-pref-provider-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  grid-gap: 16px;
}

.user-pref-provider-header p {
  font-size: 0.75rem;
}

.user-pref-provider-header h2 {
  font-size: 1.5rem;
}

.user-pref-provider-header {
  margin: 1rem;
  color: var(--text-primary);
}

.user-pref-provider-count {
  font-size: 0.875rem;
  color: var(--text-primary);
  margin-top: 0.5rem;
  font-weight: 500;
}

.user-pref-provider-logo {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: var(--theme-consistent) 0px 0px 2px 0px;
  overflow: hidden;
  transition: transform 0.2s ease;
  height: 120px;
}

.user-pref-provider-logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}

.user-pref-provider-image {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-pref-provider-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
}

.user-pref-provider-label {
  font-size: 0.75rem;
  text-align: center;
  color: var(--text-consistent);
  margin-top: 4px;
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  padding: 4px;
  line-height: 1.2;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  width: 100%;
  height: 100%;
}

.user-pref-provider-logo.selected {
  box-shadow: var(--theme-consistent) 0px 0px 0px 2px;
}

.user-pref-provider-logo:active {
  transform: scale(0.95);
}

.user-pref-selected-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.user-pref-checkmark {
  color: white;
  font-size: 1.5rem;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
}

.user-pref-feedback-message {
  position: fixed;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 12px 24px;
  border-radius: 20px;
  z-index: 1000;
  animation: fadeInOut 2s ease-in-out;
  width: auto;
  max-width: 90%;
  text-align: center;
  margin-bottom: env(safe-area-inset-bottom, 0px);
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translate(-50%, 20px); }
  15% { opacity: 1; transform: translate(-50%, 0); }
  85% { opacity: 1; transform: translate(-50%, 0); }
  100% { opacity: 0; transform: translate(-50%, -20px); }
}

.user-pref-no-providers-message {
  text-align: center;
  padding: 20px;
  background-color: #f8f8f8;
  border-radius: 8px;
  margin-top: 20px;
  font-size: 16px;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/assets/UserPreferences.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mDAAmD;EACnD,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,KAAK,UAAU,EAAE,gCAAgC,EAAE;EACnD,MAAM,UAAU,EAAE,6BAA6B,EAAE;EACjD,MAAM,UAAU,EAAE,6BAA6B,EAAE;EACjD,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb","sourcesContent":[".user-pref-provider-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  grid-gap: 16px;\n}\n\n.user-pref-provider-header p {\n  font-size: 0.75rem;\n}\n\n.user-pref-provider-header h2 {\n  font-size: 1.5rem;\n}\n\n.user-pref-provider-header {\n  margin: 1rem;\n  color: var(--text-primary);\n}\n\n.user-pref-provider-count {\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  margin-top: 0.5rem;\n  font-weight: 500;\n}\n\n.user-pref-provider-logo {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 10px;\n  box-shadow: var(--theme-consistent) 0px 0px 2px 0px;\n  overflow: hidden;\n  transition: transform 0.2s ease;\n  height: 120px;\n}\n\n.user-pref-provider-logo-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.user-pref-provider-image {\n  width: 100%;\n  height: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.user-pref-provider-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 4px;\n}\n\n.user-pref-provider-label {\n  font-size: 0.75rem;\n  text-align: center;\n  color: var(--text-consistent);\n  margin-top: 4px;\n  max-width: 100%;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n  padding: 4px;\n  line-height: 1.2;\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n}\n\n.user-pref-provider-logo.selected {\n  box-shadow: var(--theme-consistent) 0px 0px 0px 2px;\n}\n\n.user-pref-provider-logo:active {\n  transform: scale(0.95);\n}\n\n.user-pref-selected-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n}\n\n.user-pref-checkmark {\n  color: white;\n  font-size: 1.5rem;\n  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.user-pref-feedback-message {\n  position: fixed;\n  bottom: 100px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 12px 24px;\n  border-radius: 20px;\n  z-index: 1000;\n  animation: fadeInOut 2s ease-in-out;\n  width: auto;\n  max-width: 90%;\n  text-align: center;\n  margin-bottom: env(safe-area-inset-bottom, 0px);\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translate(-50%, 20px); }\n  15% { opacity: 1; transform: translate(-50%, 0); }\n  85% { opacity: 1; transform: translate(-50%, 0); }\n  100% { opacity: 0; transform: translate(-50%, -20px); }\n}\n\n.user-pref-no-providers-message {\n  text-align: center;\n  padding: 20px;\n  background-color: #f8f8f8;\n  border-radius: 8px;\n  margin-top: 20px;\n  font-size: 16px;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
